import { chain, get } from "lodash"
import { ALL_DATASET_ACCESS_TEAM } from "helpers/datasets"
import { createSelector } from "reselect"
import { getIsSuperuser } from "modules/account-root/selectors"
import { getRoute, getPath } from "selectors/urls"
import { computeDatasetPermissionsTabs } from "helpers/permissions/tabs"

export const getDatasetTeams = (state) => get(state, "global.data.datasetTeamEntitlements.data")

// Dont want all access team in the Add Team dropdown menu
export const getTeams = (_, props) => chain(props)
  .get("teams.teams")
  .filter(team => team.alias !== ALL_DATASET_ACCESS_TEAM.ALIAS)
  .value()

export const getTabs = createSelector(
  [getRoute, getPath, getIsSuperuser],
  computeDatasetPermissionsTabs,
)
